<template>
  <IconsPushStatus
    v-if="icon.includes('push-status')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
</template>

<script>
import IconsPushStatus from 'components/icons/push/IconsPushStatus'
export default {
  name: 'IconsPush',
  components: {
    IconsPushStatus,
  },
  props: { icon: String, color: String, width: [Number, String], height: [Number, String] },
}
</script>

<style scoped></style>
